import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOMeta from '@/components/base/SEOMeta';
import StructuredData from '@/components/base/StructuredData';
import ComicCard from '@/components/feature/ComicCard';
import { allComics, categories } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const comics = allComics.filter((c) => c.category === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-emotion-sad-line text-4xl text-foreground-300"></i>
            </div>
            <p className="text-foreground-500">分类不存在</p>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 text-sm whitespace-nowrap">
              返回首页
            </Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <SEOMeta
        title={`${category.name}漫画 - 樱花动漫91${category.name}漫画全集下拉式阅读`}
        description={`樱花动漫91${category.name}漫画专区，${category.description}。提供${category.name}漫画全集下拉式阅读，最新${category.name}漫画每日更新，免费在线看。`}
        keywords={`${category.name}漫画,${category.name}漫画大全,免费${category.name}漫画,下拉式${category.name}漫画,樱花动漫91`}
        canonicalUrl={`https://yinghuadongman91.com/category/${slug}`}
      />
      <StructuredData
        type="WebPage"
        data={{
          name: `${category.name}漫画 - 樱花动漫91`,
          description: category.description,
          url: `https://yinghuadongman91.com/category/${slug}`,
        }}
      />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: `${category.name}漫画` },
              ]}
            />

            <div className="bg-white rounded-xl p-6 md:p-8 mb-8">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-14 h-14 bg-primary-50 rounded-xl flex items-center justify-center">
                  <i className={`${category.icon} text-2xl text-primary-500`}></i>
                </div>
                <div>
                  <h1 className="font-heading text-2xl md:text-3xl text-foreground-950">
                    {category.name}漫画
                  </h1>
                  <p className="text-sm text-foreground-500 mt-1">
                    共 <strong>{comics.length}</strong> 部作品
                  </p>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">{category.description}</p>
            </div>

            {comics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-5 pb-14">
                {comics.map((comic) => (
                  <ComicCard key={comic.id} {...comic} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-book-open-line text-4xl text-foreground-300"></i>
                </div>
                <p className="text-foreground-500">该分类暂无漫画</p>
              </div>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}